import VetQuestApi from "./VetQuestApi";
import { ISearchBarOptionModel, ResponseModel } from "@/models";

export abstract class DocumentService {
  static GetGuildelines = async (): Promise<ResponseModel<string>> => {
    let response = new ResponseModel<string>(0, "");
    try {
      const { data, status } = await VetQuestApi().get<string>("document");
      if (data && status === 200) {
        response = new ResponseModel<string>(status, data);
      }
      return response;
    } catch (error) {
      response = new ResponseModel<string>(
        error.response.status,
        "",
        error.response
      );
      return response;
    }
  };
}
